/**
 * Tiny module-level holder for the current staff token. The login flow writes
 * it; the API client reads it to attach `Authorization: Bearer <token>`.
 * The backend NEVER trusts client identity — it verifies this token server-side.
 */
let currentToken: string | undefined;

export function setAuthToken(token: string | undefined): void {
  currentToken = token;
}

export function getAuthToken(): string | undefined {
  return currentToken;
}
